import { cn } from "@/lib/utils";

const MARK = "/brand/bloq-mark.png"; // icon-only "b" waveform mark (aspect w/h ≈ 0.58)
const WORDMARK = "/brand/bloq-wordmark.png"; // "BLOQTALK" wordmark, TALK white (dark bg)
const WORDMARK_DARK = "/brand/bloq-wordmark-dark.png"; // TALK black (light bg)
const STACKED = "/brand/bloq-stacked.png"; // icon above wordmark, square lockup (dark bg)
const STACKED_DARK = "/brand/bloq-stacked-dark.png"; // TALK black (light bg)

// Icon-only mark. `size` = rendered height in px.
export function BloqMark({ size = 40, className = "", animate = false }) {
  return (
    <img
      src={MARK}
      alt="BLOQ Talk"
      draggable={false}
      style={{ height: size, width: "auto" }}
      className={cn(animate && "animate-pulse-glow", className)}
      data-testid="bloq-mark"
    />
  );
}

// Full stacked lockup (icon above wordmark). `size` = rendered width in px.
// `dark` = the surface is light, so render the black-"TALK" variant.
export function BloqStacked({ size = 160, className = "", dark = false }) {
  return (
    <img
      src={dark ? STACKED_DARK : STACKED}
      alt="BLOQ Talk"
      draggable={false}
      style={{ width: size, height: "auto" }}
      className={className}
      data-testid="bloq-stacked"
    />
  );
}

// Horizontal lockup: icon + wordmark. `size` = wordmark height in px.
// `dark` = the surface is light, so render the black-"TALK" variant.
export function BloqLogo({ size = 26, className = "", dark = false }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="bloq-logo">
      <img src={MARK} alt="" draggable={false} style={{ height: size * 1.55, width: "auto" }} />
      <img src={dark ? WORDMARK_DARK : WORDMARK} alt="BLOQ Talk" draggable={false} style={{ height: size, width: "auto" }} />
    </div>
  );
}
